import { useEffect, useRef, useState } from "react";

const TOKEN_KEY = "palco_token";
const subs = new Set();
const statusSubs = new Set();
let ws = null, connected = false, retry = 0, pingT = null, reconnectT = null, lastSeq = 0;

function setConnected(v) { connected = v; statusSubs.forEach((f) => f(v)); }

function open() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token || ws) return;
  ws = new WebSocket(`${process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws")}/api/ws/express`);
  ws.onopen = () => { ws.send(JSON.stringify({ auth: token })); retry = 0; setConnected(true); pingT = setInterval(() => ws?.readyState === 1 && ws.send("ping"), 25000); };
  ws.onmessage = (m) => {
    let msg; try { msg = JSON.parse(m.data); } catch { return; }
    if (msg.type === "pong") return;
    if (msg.type === "hello") { subs.forEach((f) => f({ type: "resync" })); return; }
    if (msg.seq && msg.seq <= lastSeq) return;
    lastSeq = msg.seq || lastSeq;
    subs.forEach((f) => f(msg));
  };
  ws.onclose = (ev) => {
    clearInterval(pingT); ws = null; setConnected(false);
    if (!subs.size || ev.code === 4401) return;
    retry = Math.min(retry + 1, 6);
    reconnectT = setTimeout(open, 1000 * 2 ** (retry - 1));
  };
  ws.onerror = () => { try { ws?.close(); } catch { /* noop */ } };
}

// Assinatura em tempo real (WebSocket com reconexão). `connected` permite cair para atualização periódica.
export function useExpressLive(handler) {
  const ref = useRef(handler);
  ref.current = handler;
  const [isOn, setOn] = useState(connected);
  useEffect(() => {
    const f = (msg) => ref.current?.(msg);
    subs.add(f); statusSubs.add(setOn);
    open();
    return () => {
      subs.delete(f); statusSubs.delete(setOn);
      if (!subs.size) { clearTimeout(reconnectT); try { ws?.close(); } catch { /* noop */ } }
    };
  }, []);
  return isOn;
}

// Atualiza via WS e mantém um fallback periódico (mais lento quando conectado).
export function useLiveRefresh(load, { match, slow = 20000, fast = 5000 } = {}) {
  const on = useExpressLive((msg) => { if (msg.type === "resync" || !match || match(msg)) load(); });
  useEffect(() => { load(); const t = setInterval(load, on ? slow : fast); return () => clearInterval(t); }, [load, on, slow, fast]);
  return on;
}
